export function mlsPurchaseOrderTypeChip(row) {
  const kind = row.purchase_order_kind
  if (kind === "mixed") {
    return { label: "Mixed", color: "secondary", variant: "filled" }
  }
  if (kind === "credentials" || row.is_credential_order) {
    return { label: "Credentials", color: "warning", variant: "filled" }
  }
  return { label: "Catalog", color: "default", variant: "outlined" }
}

export function mlsPurchaseOrderTypeLabel(row) {
  const kind = row.purchase_order_kind
  if (kind === "mixed") {
    return "Catalog + custom credentials"
  }
  if (kind === "credentials" || row.is_credential_order) {
    return "MLS credentials"
  }
  return "Catalog MLS"
}

export function mlsPurchaseLinesIncludePasswords(row) {
  const kind = row.purchase_order_kind
  return kind === "credentials" || kind === "mixed" || row.is_credential_order
}

/** Who pays for the order's boards: a CRM deal sale, the order itself, or both. */
export function mlsPurchaseFundingChip(row) {
  if (row.funding === "deal") {
    return { label: "Deal sale", color: "success", variant: "filled" }
  }
  if (row.funding === "shortfall") {
    // A board meant for a deal credit another order used first: not paid.
    return { label: "Deal credit short", color: "error", variant: "filled" }
  }
  if (row.funding === "mixed") {
    return { label: "Deal sale + paid", color: "success", variant: "outlined" }
  }
  return { label: "Paid", color: "default", variant: "outlined" }
}
